import { inject, Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { catchError, Observable } from 'rxjs';
import { VenueService } from '@doc/api/server-bo';

@Injectable({
  providedIn: 'root'
})
export class VenueResolver implements Resolve<any> {

  private venueService= inject(VenueService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.venueService.getAllVenues({}).pipe(
      catchError(error => {
        return [];
      })
    )
  }
}
